<template>
    <div class="clientDetail">
      <!--navBar-->
      <navBar></navBar>
      <!--中间内容部分-->
      <div class="main">
        <div class="mainContainer">
          <div class="nav_detail">
            <span class="nav_back" @click="goBack">案例中心</span> > <span>台州大数据管理中心</span>
          </div>
          <div class="flex_between">
            <div class="item_left">
              <div class="icon"><i></i></div>
              <p class="title">台州大数据管理中心</p>
              <div class="intro">
                <div>客户简介</div>
                <p>台州市大数据管理中心为台州市政府直属正县级事业单位，主要负责全市大数据资源统筹管理工作。</p>
              </div>
              <div class="products">
                <div>使用产品</div>
                <p @click="goProduct('/solution2')">网站全时安全管控方案</p>
                <p @click="goProduct('/product2')">渗透测试</p>
                <p @click="goProduct('/product1')">漏洞扫描</p>
                <p @click="goProduct('/product3')">专家服务</p>
              </div>
            </div>
            <div class="item_right">
              <div class="title">
                <i></i>业务背景
              </div>
              <p>2017年国家颁布并实施了《网络安全法》，保障网络安全、稳定运行，有效应对网络安全事件，防范网络违法犯罪活动等都是国家政策的重要体现；台州大数据中心承载着多种社会公众网站，极有可能成为国内外诸多不法分子的攻击目标，人工安全检测效率低下，响应速度慢，遇到事故无法及时止损，因此如何做好网站的安全管控显得尤为重要。</p>
              <div class="item_img"><img src="../../assets/img/clientDetail/client5_big.jpg" alt=""></div>
              <div class="title">
                <i></i>解决方案
              </div>
              <p>先黑客一步发现风险：通过模拟真实的黑客攻击手段，从海量蜜罐系统中提取数据，筛选出无数可穿墙的程序代码，最后再编译到牛盾漏洞扫描规则库中，真正做到先黑客一步发现问题，助力政府、企业和个人打造安全、稳定、高效的业务应用环境。秒封秒解：牛盾网络独创“秒封秒解”技术，通过分析流量数据包，实时检测安全威胁，封禁相关问题端口和URL，将安全问题网站及时封停，待问题解决后及时解封，最大限度地降低危害和不良影响。</p>
              <div class="title">
                <i></i>方案价值
              </div>
              <p>多向性安全防护能力、旁路网站防护能力、网络数据安全审计能力，全方位保障网站安全可用性，做到事前风险自检、事中快速响应、事后及时解决，全面解决云平台面临的威胁。为台州大数据中心提供更专业和高效的网站管控服务，提高工作效率，提升网站服务能力，响应数字智慧化办公的建设思想，促进数字化办公的发展。</p>
            </div>
          </div>
        </div>
      </div>
      <!--footerBar-->
      <div class="gw_homefooterBox">
        <footerBar></footerBar>
      </div>
    </div>
</template>

<script>
    import navBar from '../../components/Navbar';
    import footerBar from '../../components/footerbar'
    export default {
      components:{
        navBar,footerBar
      },
      methods:{
        goBack(){
          this.$router.push('/client');
        },
        goProduct(url){
          this.$router.push(url);
          window.scrollTo({top:0});
        }
      }
    }
</script>

<style scoped lang="scss">
  .clientDetail{
    .item_left{
      .icon{
        i{
          width:121px;
          height:48px;
          background:url("../../assets/img/clientDetail/client5_icon.png") no-repeat center;
          background-size:100% 100%;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/client/client5.vue